import { createAsyncThunk } from "@reduxjs/toolkit";
import { phpClient } from "../../../network";
import { IRejectWithValue } from "../../../types";
import { format } from "date-fns";

export interface LastPunchResponse {
  status: boolean;
  message: string;
  data: {
    source: 'raw' | 'clockio';
    datetime: string;
    punch_status: 0 | 1 | 2 | 3; // 0=Clock In, 1=Clock Out, 2=Break In, 3=Break Out
    site_id: string;
    workcode: string;
    reset_punch_state: boolean;
  };
}

export interface CreatePunchRequest {
  status: 0 | 1 | 2 | 3; // 0=Clock In, 1=Clock Out, 2=Break In, 3=Break Out
  datetime?: string; // optional, will be set to now if not provided
  attendance_tags_json?: Record<string, string | string[]>[]; // optional attendance tags
  other_info_json?: Record<string, any>; // optional additional info like notes
  // Add other optional fields as needed
}

// export interface PunchHistoryRequest {
//   start_date?: string;
//   end_date?: string;
//   employee_id?: string;
//   limit?: number;
//   offset?: number;
// }

// export interface PunchHistoryItem {
//   id: string;
//   type: 'in' | 'out' | 'break_start' | 'break_end';
//   timestamp: string;
//   location?: {
//     lat: number;
//     lng: number;
//     address: string;
//   };
//   notes?: string;
//   employee_id?: string;
//   shift_id?: string;
// }

// Get last punch for the authenticated employee
export const getLastPunch = createAsyncThunk<LastPunchResponse['data'] | null, void, IRejectWithValue>(
  "punch/getLastPunch",
  async (_, { rejectWithValue }) => {
    try {
      const datetime = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
      const response = await phpClient.get<LastPunchResponse>({
        url: `/webclock/lastpunch?datetime=${encodeURIComponent(datetime)}`,
      });

      if (response.status && response.data) {
        return {
          ...response.data,
          punch_status: Number(response.data.punch_status) as 0 | 1 | 2 | 3,
        };
      } else {
        return null;
      }
    } catch (e) {
      return rejectWithValue((e as Error).message || "Failed to fetch last punch");
    }
  }
);

// Create a new punch
export const createPunch = createAsyncThunk<void, CreatePunchRequest, IRejectWithValue>(
  "punch/createPunch",
  async (punchData, { rejectWithValue }) => {
    try {
      const now = format(new Date(), "yyyy-MM-dd HH:mm:ss");
      const payload = {
        ...punchData,
        datetime: punchData.datetime || now,
        punch_source_id: 3, // mobile
        verified: 1,
        auto_status_update_flag: 1,
        other_info_json: {
          recive_punch_source: 'REACTJS_KIOSK',
          ...(punchData.other_info_json || {})
        },
      };
      const response: { status: boolean; message?: string } = await phpClient.post({
        url: "/webclock/mobile_punch",
        data: payload,
      });
      console.log(response);
      if (response.status === false) {
        return rejectWithValue(response.message || "Failed to punch.");
      }
    } catch (e) {
      return rejectWithValue((e as Error).message || "Failed to create punch");
    }
  }
);

// Get punch history
// export const getPunchHistory = createAsyncThunk<PunchHistoryItem[], PunchHistoryRequest, IRejectWithValue>(
//   "punch/getPunchHistory",
//   async (params, { rejectWithValue }) => {
//     try {
//       const response = await phpClient.get<PhpResponse<PunchHistoryItem[]>>({
//         url: "/webclock/punch_history",
//         params,
//       });
//       return response.data || [];
//     } catch (e) {
//       return rejectWithValue((e as Error).message || "Failed to fetch punch history");
//     }
//   }
// );

// // Get today's punches
// export const getTodayPunches = createAsyncThunk<PunchHistoryItem[], void, IRejectWithValue>(
//   "punch/getTodayPunches",
//   async (_, { rejectWithValue }) => {
//     try {
//       const today = format(new Date(), 'yyyy-MM-dd');
//       const response = await phpClient.get<PhpResponse<PunchHistoryItem[]>>({
//         url: `/webclock/today_punches?date=${today}`,
//       });
//       return response.data || [];
//     } catch (e) {
//       return rejectWithValue((e as Error).message || "Failed to fetch today's punches");
//     }
//   }
// ); 